import { useNavigate } from "react-router-dom"
import { formatConfidence, formatDateToShortString, formatDateToTodayTime, formatLift, formatSupport, getStrength } from "../../../../common/common";
import { setIsFavoriteSku, setSearchQueryForItemsets as setSearchQueryForItemsetsParents,setSelectedItemSetForProductPage,setSortBy as setSortByParents } from "../../../../../store";
import { useDispatch, useSelector } from "react-redux";


let percentageArray = [
    0.01, 0.02, 0.03, 0.04, 0.05,
    0.10, 0.20, 0.30, 0.40, 0.50,
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10
]

const AnalysisResultHeader = ({
    switchTab,
    setSwitchTab,
    currentAnalysisData,
    reportId,
    displayAnalysisResult,
    highestLiftRule,
    uniqueProducts,
    start_date,
    end_date,
    searchQueryForItemsets,
    setSearchQueryForItemsets,
    supportFilter,
    setSupportFilter,
    selectedCombo,
    setSelectedCombo,
    countItemSet,
    sortBy,
    setSortBy,
    setCurrentPage,
    order_details_id
}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const searchQueryForItemsetsParents = useSelector((state) => state.analysisData.searchQueryForItemsets);
    const isFavoriteSku = useSelector((state) => state.analysisData.isFavoriteSku);
    const isProductPage = useSelector((state) => state.analysisData.isProductPage);
    const selectedItemSetForProductPage = useSelector((state) => state.analysisData.selectedItemSetForProductPage);



    const totalBundles = useSelector((state) => state.analysisData.totalBundles);
	const avgItemPerBundle = useSelector((state) => state.analysisData.avgItemPerBundle);
	const avgConversionRate = useSelector((state) => state.analysisData.avgConversionRate);

    const sortByParents = useSelector((state) => state.analysisData.sortBy);

    const handleSupportChange = (e) => {
        const value = e.target.value;
        setSupportFilter(value);
    };
    const handleExportCSV = () => {
            const rows = displayAnalysisResult;
            const header = [
                "Antecedents",
                "Consequents",
                "Support",
                "Confidence",
                "Lift",
                "Antecedent Support",
                "Consequent Support",
                "Strength",
            ];
            const csvContent = [
                header.join(","),
                ...rows.map((r) =>
                    [
                        `"${r.antecedents.map((a) => a.product_title).join(" + ")}"`,
                        `"${r.consequent.map((c) => c.product_title).join(" + ")}"`,
                        `${formatSupport(r.support)}%`,
                        `${formatConfidence(r.confidence)}%`,
                        formatLift(r.lift),
                        `${formatSupport(r.antecedent_support)}%`,
                        `${formatSupport(r.consequent_support)}%`,
                        // r.confidence >= 0.6
                        // 	? "strong"
                        // 	: r.confidence >= 0.3
                        // 	? "modrate"
                        // 	: "weak",
                        getStrength(r)
                    ].join(",")
                ),
            ].join("\n");
            const blob = new Blob([csvContent], { type: "text/csv" });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `analysis_results_items.csv`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
    };


    return (
        <>
            <div class="bg-white glass-container rounded-xl p-6 relative overflow-hidden shadow-sm hover:shadow-md transition-shadow mb-5">
                <div class="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6">
                    <div>
                        <h1 class="text-[1.75rem] font-[800] text-black-800 dark:text-black-100" >
                            <span
                                className=" text-lg cursor-pointer"
                                onClick={() => navigate(-1)}
                            >
                                ←
                            </span> Order Report {reportId}
                            
                        </h1>
                        <p class="text-[0.9rem] text-black-500 dark:text-black-400">

                            Processed{" "}
                            {currentAnalysisData?.totalOrder?.toLocaleString(
                                "en-US"
                            ) ?? 0}{" "}
                            orders with{" "}
                            {currentAnalysisData?.totalProduct?.toLocaleString(
                                "en-US"
                            ) ?? 0}{" "}
                            products. Found{" "}

                            {currentAnalysisData?.totalItemSets ?? 0}{" "}
                            significant itemsets.

                            
                        </p>
                        
                    </div>
                    <div className="flex gap-3">
                        {/* Tab 1 - Association Rules */}
                        <button
                            className={`flex items-center gap-2 px-4 py-2 rounded-full border-2 transition-all duration-300 ${switchTab === 1
                                ? 'border-indigo-500 bg-indigo-50 text-indigo-700 shadow-sm'
                                : 'border-gray-300 text-gray-600 hover:bg-gray-100'
                                }`}
                            onClick={() => {
                                setSwitchTab(1)
                                dispatch(setIsFavoriteSku(false))
                            }}
                        >
                            <i className="fas fa-project-diagram text-indigo-500"></i>
                            <span className="text-sm font-semibold">Association Rules & Product Pair Analysis</span>
                        </button>

                        {/* Tab 2 - Product Bundles */}
                        <button
                            className={`flex items-center gap-2 px-4 py-2 rounded-full border-2 transition-all duration-300 ${switchTab === 2
                                ? 'border-green-500 bg-green-50 text-green-700 shadow-sm'
                                : 'border-gray-300 text-gray-600 hover:bg-gray-100'
                                }`}
                            onClick={() => setSwitchTab(2)}
                        >
                            <i className="fas fa-layer-group text-green-500"></i>
                            <span className="text-sm font-semibold">Product Bundles</span>
                        </button>

                        <button
                            className={`flex items-center gap-2 px-4 py-2 rounded-full border-2 transition-all duration-300 ${
                                switchTab === 3
                                ? 'border-red-500 bg-red-50 text-red-700 shadow-sm'
                                : 'border-gray-300 text-gray-600 hover:bg-gray-100'
                            }`}
                            onClick={() => setSwitchTab(3)}
                            >
                            <i
                                className={`fas fa-heart ${
                                switchTab === 3 ? 'text-red-500' : 'text-gray-400'
                                }`}
                            ></i>
                            <span className="text-sm font-semibold">Favorite</span>
                        </button>

                        <button
                        className={`flex items-center gap-2 px-4 py-2 rounded-full border-2 transition-all duration-300 ${
                            switchTab === 4
                            ? 'border-blue-500 bg-blue-50 text-blue-700 shadow-sm'
                            : 'border-gray-300 text-gray-600 hover:bg-gray-100'
                        }`}
                        onClick={() => setSwitchTab(4)}
                        >
                        <i className={`fas fa-boxes ${switchTab === 4 ? 'text-blue-500' : 'text-gray-400'}`}></i>
                        <span className="text-sm font-semibold">SKU Report</span>
                        </button>
                    </div>
                </div>

                <div class="flex flex-col md:flex-row gap-3 mb-6 items-center">
                    { switchTab !== 4 &&    
                        <div className="relative w-full">
                        <input
                            type="text"
                            placeholder={`${(switchTab === 1 || switchTab===3) ? 'Search by product name or sku...' : 'Search by product name or sku...'}`}
                            className={`${(switchTab === 1 || switchTab===3) ? 'w-3/4' : 'w-1/2'} pl-9 pr-4 py-2 text-sm border border-border-light rounded-lg focus:outline-none focus:ring-1 focus:ring-button-blue`}
                            value={(switchTab === 1 || switchTab===3) ? searchQueryForItemsets : searchQueryForItemsetsParents}
                            onChange={(e) => {
                                (switchTab === 1 || switchTab===3) ? setSearchQueryForItemsets(e.target.value) : dispatch(setSearchQueryForItemsetsParents(e.target.value))
                            }}
                        />
                        <svg
                            className="absolute left-3 top-2.5 h-4 w-4 text-gray-400"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                            />
                        </svg>
                        </div>
                    }
                    <div class="flex gap-2 self-stretch md:self-center">
                        {
                            switchTab === 2 &&
                            <>
                                <select
                                    class="bg-white text-sm border border-border-light rounded-lg px-3 py-2 focus:outline-none focus:ring-1 focus:ring-button-blue"
                                    value={supportFilter}
                                    onChange={handleSupportChange}

                                >
                                    {(() => {
                                        const currentSupport = currentAnalysisData?.min_support * 100;
                                        const isSupportAlreadyExists = percentageArray.some(check => check == currentSupport);

                                        if (!isSupportAlreadyExists) {
                                            const minOrders = Math.ceil(Math.round((currentSupport / 100) * currentAnalysisData?.totalOrder));
                                            return (
                                                <option value={currentSupport}>
                                                    {currentSupport}% (min {minOrders} orders)
                                                </option>
                                            );
                                        }

                                        return null;
                                    })()}
                                    {
                                        percentageArray.map((data, index) => {
                                            let minValue = Math.round(
                                                data/100 * currentAnalysisData?.totalOrder
                                              )
                                            let currentSupport = currentAnalysisData?.min_support*100
                                            const isSupportAlreadyExists = percentageArray.some(check => check == currentSupport);

                                            let check = isSupportAlreadyExists ? data >= currentSupport : data > currentSupport
                                            if(check){
                                                return <option value={Number(data)}>
                                                    {data}% (min {Math.ceil(minValue)} orders)
                                                </option>
                                            }
                                        })
                                    }
                                </select>
                                <select
                                    class="bg-white text-sm border border-border-light rounded-lg px-3 py-2 focus:outline-none focus:ring-1 focus:ring-button-blue mr-5"
                                    value={sortByParents}
                                    onChange={(e) => dispatch(setSortByParents(e.target.value))}
                                >
                                    <option value="">Sort By</option>
                                    <option value="hl">Highest Lift</option>
                                    <option value="ll">Lowest Lift</option>
                                    <option value="hs">Highest Support</option>
                                    <option value="ls">Lowest Support</option>
                                    <option value="hc">Highest Confidence</option>
                                    <option value="lc">Lowest Confidence</option>
                                </select>
                            </>
                        }
                        {
                            (switchTab === 1 || switchTab === 3) &&
                            <>
                                { !isFavoriteSku &&
                                    
                                    <select
                                    class="bg-white text-sm border border-border-light rounded-lg px-3 py-2 focus:outline-none focus:ring-1 focus:ring-button-blue"
                                    value={selectedCombo}
                                    onChange={(e) => {
                                        setSelectedCombo(Number(e.target.value))
                                        setCurrentPage(1)
                                    }
                                    }
                                >

                                    <option value={1}>
                                        1- combinations [{countItemSet.item_set_1}{" "}
                                        Records]
                                    </option>
                                    <option value={2}>
                                        2- combinations [{countItemSet.item_set_2}{" "}
                                        Records]
                                    </option>
                                    <option value={3}>
                                        3- combinations [{countItemSet.item_set_3}{" "}
                                        Records]
                                    </option>
                                    <option value={4}>
                                        4- combinations [{countItemSet.item_set_4}{" "}
                                        Records]
                                    </option>
                                    <option value={0}>
                                        All-combinations [
                                        {countItemSet.item_set_all} Records]
                                    </option>
                                </select>
                                }

                                {
                                    switchTab === 3 && isProductPage && 
                                    <select
                                    value={selectedItemSetForProductPage}
                                    onChange={(e) => dispatch(setSelectedItemSetForProductPage(parseInt(e.target.value)))}
                                    class="bg-white text-sm border border-border-light rounded-lg px-3 py-2 focus:outline-none focus:ring-1 focus:ring-button-blue"
                                    >
                                        <option value={1}>1 Itemset</option>
                                        <option value={2}>2 Itemsets</option>
                                        <option value={3}>3 Itemsets</option>
                                        <option value={4}>4 Itemsets</option>
                                        <option value={0}>All</option>
                                    </select>
                                }
                                
                                    <select
                                            class="bg-white text-sm border border-border-light rounded-lg px-3 py-2 focus:outline-none focus:ring-1 focus:ring-button-blue"
                                            value={sortBy}
                                            onChange={(e) => setSortBy(e.target.value)}
                                        >
                                            <option value="hl">Sort by: Highest Lift (Default)</option>
                                            <option value="ll">Sort by: Lowest Lift</option>
                                            <option value="hs">Sort by: Highest Support</option>
                                            <option value="ls">Sort by: Lowest Support</option>
                                            <option value="hc">Sort by: Highest Confidence</option>
                                            <option value="lc">Sort by: Lowest Confidence</option>
                                            <option value="strong">Sort by: Strong</option>
                                            <option value="weak">Sort by: Weak/Modrate</option>
                                        </select>
                                
                                <select
                                    class="bg-white text-sm border border-border-light rounded-lg px-3 py-2 focus:outline-none focus:ring-1 focus:ring-button-blue"
                                    value={supportFilter}
                                    onChange={handleSupportChange}

                                >
                                    {(() => {
                                        const currentSupport = currentAnalysisData?.min_support * 100;
                                        const isSupportAlreadyExists = percentageArray.some(check => check == currentSupport);

                                        if (!isSupportAlreadyExists) {
                                            const minOrders = Math.ceil(Math.round((currentSupport / 100) * currentAnalysisData?.totalOrder));
                                            return (
                                                <option value={currentSupport}>
                                                    {currentSupport}% (min {minOrders} orders)
                                                </option>
                                            );
                                        }

                                        return null;
                                    })()}
                                    {
                                        percentageArray.map((data, index) => {
                                            let minValue = Math.round(
                                                data/100 * currentAnalysisData?.totalOrder
                                              )
                                            let currentSupport = currentAnalysisData?.min_support*100
                                            const isSupportAlreadyExists = percentageArray.some(check => check == currentSupport);

                                            let check = isSupportAlreadyExists ? data >= currentSupport : data > currentSupport
                                            if(check){
                                                return <option value={Number(data)}>
                                                    {data}% (min {Math.ceil(minValue)} orders)
                                                </option>
                                            }
                                        })
                                    }
                                </select>
                                {
                                    switchTab === 1 &&
                                    <button class="button-hover p-2 rounded-lg border border-purple-200 dark:border-purple-900/50 text-purple-500 dark:text-purple-300 transition"
                                    onClick={handleExportCSV}
                                >
                                    <i class="fas fa-file-export"></i>
                                </button>
                                }
                            </>
                        }
                    </div>
                </div>

               

                {
                    switchTab === 1 &&
                    <div class="bg-blue-50 rounded-lg p-4 mt-6"><div class="flex flex-wrap justify-center md:justify-between items-center"><div class="flex items-center mb-2 md:mb-0"><div class="bg-blue-100 p-3 rounded-full mr-3"><i class="fas fa-shopping-cart text-blue-600"></i></div><div><p class="text-sm text-gray-600">Total Combinations <span class="ml-1 text-[#5E7BAA]" data-tooltip="Generated via FP-Growth algorithm">ⓘ</span></p><p class="text-xl font-bold text-blue-700">{displayAnalysisResult.length} Combinations</p></div></div><div class="flex items-center mb-2 md:mb-0"><div class="bg-green-100 p-3 rounded-full mr-3"><i class="fas fa-users text-green-600"></i></div><div><p class="text-sm text-gray-600">Unique Products <span class="ml-1 text-[#5E7BAA]" data-tooltip="Generated via FP-Growth algorithm">ⓘ</span></p><p class="text-xl font-bold text-green-700">{uniqueProducts} products</p></div></div><div class="flex items-center"><div class="bg-purple-100 p-3 rounded-full mr-3"><i class="fas fa-percentage text-purple-600"></i></div><div><p class="text-sm text-gray-600">Highest Lift <span class="ml-1 text-[#5E7BAA]" data-tooltip="Generated via FP-Growth algorithm">ⓘ</span></p><p class="text-xl font-bold text-purple-700">{formatLift(highestLiftRule)}</p></div></div></div></div>
                }


                {
                    switchTab === 2 &&
                    <div class="bg-blue-50 rounded-lg p-4 mt-6">
                        <div class="flex flex-wrap justify-center md:justify-between items-center">
                            <div class="flex items-center mb-2 md:mb-0">
                                <div class="bg-blue-100 p-3 rounded-full mr-3"><i class="fas fa-boxes text-blue-600 text-lg"></i></div><div>
                                    <p class="text-sm text-gray-600">Total Bundles
                                        <span class="ml-1 text-[#5E7BAA]" data-tooltip="Shows the total number of bundles">ⓘ</span></p><p class="text-xl font-bold text-blue-700">{totalBundles} </p>
                                </div></div>
                            <div class="flex items-center mb-2 md:mb-0">
                                <div class="bg-green-100 p-3 rounded-full mr-3">
                                    <i class="fas fa-chart-line text-green-600 text-lg">
                                    </i></div>
                                <div><p class="text-sm text-gray-600">Avg. Item Per Bundles <span class="ml-1 text-[#5E7BAA]" data-tooltip="Avg number of items that frequently appear together in a bundle.">ⓘ</span></p><p class="text-xl font-bold text-green-700">{avgItemPerBundle} </p>
                                </div>
                            </div>
                            <div class="flex items-center">
                                <div class="bg-purple-100 p-3 rounded-full mr-3">
                                    <i class="fas fa-percentage text-red-600"></i>
                                </div>
                                <div>
                                    <p class="text-sm text-gray-600">Avg. Support <span class="ml-1 text-[#5E7BAA]" data-tooltip="This value is calculated based on how frequently this combination appears in orders">ⓘ</span></p><p class="text-xl font-bold text-purple-700">{avgConversionRate}%</p>
                                </div>
                            </div>
                        </div>
                    </div>
                }

                <div class="text-[11px] text-black-400 dark:text-black-500 flex flex-wrap justify-center gap-x-3 gap-y-1 mt-5">
                    <span><i class="fas fa-calendar-alt mr-1"></i> <b>{formatDateToShortString(start_date)}</b> to{" "}
                        <b>{formatDateToShortString(end_date)}</b></span>
                    <span class="hidden sm:inline">•</span>
                    <span><i class="fas fa-file-signature mr-1"></i> #Order Report {reportId}</span>
                    <span>•</span>
                    <span><i class="fas fa-box-open mr-1"></i>
                        {currentAnalysisData?.totalOrder?.toLocaleString("en-US") ?? 0} orders analyzed</span>
                    <span>•</span>
                    <span><i class="fas fa-file-signature mr-1"></i> #{currentAnalysisData?.analysisTitle}</span>
                    <span class="hidden sm:inline">•</span>
                    <span><i class="fas fa-clock mr-1"></i> Run on {formatDateToTodayTime(currentAnalysisData?.createdAt)}</span>
                    <span>•</span>
                    <span><i class="fas fa-percentage mr-1"></i> Min support {supportFilter || formatConfidence(currentAnalysisData?.min_support)}%</span>
                    <span class="hidden sm:inline">•</span>
                    <span><i class="fas fa-database mr-1"></i> Large Data set</span>
                    {/* <span 
                    className="cursor-pointer" 
                    onClick={()=>{
                        navigate(`/favorite`, {
                            state: {
                            order_details_id: order_details_id,
                            analysis_details_id: currentAnalysisData._id,
                            },
                        });
                    }}
                    >
                        <i class="fas fa-heart mr-1"></i> Favorite
                    </span> */}
                    
                </div>
            </div>
        </>
    )
}

export default AnalysisResultHeader;